export const ESIGN_POLLING_INTERVAL_MS = 30_000;

export interface ESignPollingState {
  activeTab: string;
  documentHidden: boolean;
  esignEmployeeOpen: boolean;
  esignOpening: Record<string, boolean>;
  esignPollingInFlight: boolean;
  esignSending: boolean;
  /** 서명 요청 보내기 모달이 열려 있는 동안은 목록을 다시 그리지 않는다(작성 중 리렌더 방지). */
  esignSendModalOpen: boolean;
  esignTemplateOpen: boolean;
}

export function shouldSkipESignPolling(state: ESignPollingState): boolean {
  return (
    state.activeTab !== "esign" ||
    state.documentHidden ||
    state.esignPollingInFlight ||
    state.esignSending ||
    state.esignSendModalOpen ||
    state.esignEmployeeOpen ||
    state.esignTemplateOpen ||
    Object.values(state.esignOpening).some(Boolean)
  );
}
